/* Estimates are display-only. Shopify remains the source of shipping charges and order dates. */
(() => {
  function businessDate(start, days, excluded) {
    const date = new Date(start);
    let remaining = days;
    for (let i = 0; remaining > 0 && i < 730; i++) {
      date.setUTCDate(date.getUTCDate() + 1);
      const key = date.toISOString().slice(0, 10);
      if (![0, 6].includes(date.getUTCDay()) && !excluded.has(key)) remaining--;
    }
    return remaining ? null : date;
  }
  function init(root = document) {
    const nodes = [...root.querySelectorAll('[data-delivery-estimate]')];
    if (root.matches?.('[data-delivery-estimate]')) nodes.unshift(root);
    nodes.forEach(node => {
      if (node.dataset.mode !== 'dates') return;
      try {
        const parts = new Intl.DateTimeFormat('en-US', {timeZone: node.dataset.timezone || 'America/New_York', year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(new Date());
        const part = type => parts.find(p => p.type === type).value;
        const start = new Date(`${part('year')}-${part('month')}-${part('day')}T12:00:00Z`);
        const min = Math.max(1, Number(node.dataset.min) || 4), max = Math.max(min, Number(node.dataset.max) || 9);
        const excluded = new Set((node.dataset.exclusions || '').match(/\d{4}-\d{2}-\d{2}/g) || []);
        const first = businessDate(start, min, excluded), last = businessDate(start, max, excluded);
        if (!first || !last) return;
        const format = new Intl.DateTimeFormat(document.documentElement.lang || 'en', {month:'short',day:'numeric',timeZone:'UTC', ...(first.getUTCFullYear() !== last.getUTCFullYear() ? {year:'numeric'} : {})});
        const estimate = min === max ? format.format(first) : `${format.format(first)}–${format.format(last)}`;
        node.querySelector('[data-delivery-message]').textContent = node.dataset.label.replace('[estimate]', estimate);
      } catch (_) { /* Keep the server-rendered business-day estimate if a setting is invalid. */ }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  new MutationObserver(records => records.forEach(record => record.addedNodes.forEach(node => {
    if (node.nodeType === 1 && (node.matches('[data-delivery-estimate]') || node.querySelector('[data-delivery-estimate]'))) init(node);
  }))).observe(document.documentElement, {childList:true,subtree:true});
})();
